if (!customElements.get('wallify-deferred-content')) {
  customElements.define('wallify-deferred-content', class extends HTMLElement {
    static scripts = new Map();
    connectedCallback() {
      if (this.started) {
        this.observeReadyHeight();
        return;
      }
      if (this.observer) return;
      if (window.Shopify?.designMode || !('IntersectionObserver' in window)) {
        this.activate();
        return;
      }
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) this.activate();
      }, { rootMargin: '800px 0px' });
      this.observer.observe(this.closest('.shopify-section') || this);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
      this.readyObserver?.disconnect();
      this.readyObserver = null;
    }
    observeReadyHeight() {
      if (!this.hasAttribute('data-wallify-ready-height') || this.hasAttribute('data-content-ready') || this.readyObserver || !this.isConnected) return;
      const threshold = Number(this.getAttribute('data-wallify-ready-height'));
      const widget = this.querySelector('loox-dynamic-carousel-widget');
      if (!widget) return;
      if (!Number.isFinite(threshold) || threshold <= 0 || !('ResizeObserver' in window)) {
        this.setAttribute('data-content-ready', 'true');
        return;
      }
      const check = () => {
        if (this.hasAttribute('data-content-ready') || !this.isConnected || widget.getBoundingClientRect().height < threshold) return;
        this.setAttribute('data-content-ready', 'true');
        this.readyObserver?.disconnect();
        this.readyObserver = null;
      };
      this.readyObserver = new ResizeObserver(check);
      this.readyObserver.observe(widget);
      check();
    }
    async activate() {
      if (this.started || !this.isConnected) return;
      const template = this.querySelector('template');
      if (!template) return;
      this.started = true;
      this.observer?.disconnect();
      this.observer = null;
      const fragment = template.content.cloneNode(true);
      const scripts = Array.from(fragment.querySelectorAll('script')).map(node => ({
        node,
        attributes: Array.from(node.attributes, attribute => [attribute.name, attribute.value]),
        text: node.textContent,
        type: node.getAttribute('type') || ''
      }));
      scripts.forEach(item => item.node.type = 'application/x-wallify-deferred');
      this.append(fragment);
      template.remove();
      this.setAttribute('data-loaded', 'true');
      this.observeReadyHeight();
      this.dispatchEvent(new CustomEvent('wallify:deferred-ready', { bubbles: true }));
      for (const item of scripts) {
        if (item.type && !['text/javascript', 'application/javascript', 'module'].includes(item.type)) {
          item.node.type = item.type;
          continue;
        }
        const source = item.attributes.find(([name]) => name === 'src')?.[1];
        if (source && this.constructor.scripts.has(source)) {
          item.node.remove();
          await this.constructor.scripts.get(source);
          continue;
        }
        const script = document.createElement('script');
        item.attributes.forEach(([name, value]) => script.setAttribute(name, value));
        script.textContent = item.text;
        if (source) {
          script.async = false;
          const loaded = new Promise(resolve => {
            script.addEventListener('load', resolve, { once: true });
            script.addEventListener('error', () => { this.constructor.scripts.delete(source); resolve(); }, { once: true });
          });
          this.constructor.scripts.set(source, loaded);
          item.node.replaceWith(script);
          await loaded;
        } else {
          item.node.replaceWith(script);
        }
      }
      this.dispatchEvent(new CustomEvent('wallify:deferred-ready', { bubbles: true }));
    }
  });
}
